import { render, staticRenderFns } from "./ui-carousel-navigation.vue?vue&type=template&id=9edd1a62&scoped=true&"
import script from "./ui-carousel-navigation.vue?vue&type=script&lang=js&"
export * from "./ui-carousel-navigation.vue?vue&type=script&lang=js&"
import style0 from "./ui-carousel-navigation.vue?vue&type=style&index=0&id=9edd1a62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edd1a62",
  null
  
)

export default component.exports